import { render, staticRenderFns } from "./ProductDetailsCard.vue?vue&type=template&id=97d1da3c&scoped=true&"
import script from "./ProductDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsCard.vue?vue&type=style&index=0&id=97d1da3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d1da3c",
  null
  
)

export default component.exports